const mainTaxFields = [
  'taxEvents',
  'taxSeries',
  'taxPersons',
  'taxSubjects',
  'taxLocations',
  'taxOrganizations',
  'taxExplorers'
];

// Excluded taxonomies are not taken into account when generating hub pages or taxonomy index,
// but must be taken into account when searching for contents of a hub page, for example.
const excludedTaxFields = [
  'taxGenres',
  'taxSources',
  'taxConcepts',
  'taxAudiences',
  'taxContentType'
];

const allTaxFields = mainTaxFields.concat(excludedTaxFields);

module.exports = {
  mainTaxFields,
  allTaxFields
};
